export { getGlobalContextClientInternal };
import { createGetGlobalContextClient } from '../shared/createGetGlobalContextClient.js';
// @ts-ignore
import * as virtualFileExports from 'virtual:vike:entry:client:server-routing';
const getGlobalContextClientInternal = createGetGlobalContextClient(virtualFileExports, false);
